/* oxlint-disable typescript/unbound-method, typescript/no-unsafe-assignment, typescript/no-unsafe-member-access, typescript/no-unsafe-return -- destructured hook returns aren't actually unbound; dynamic import() returns any by design */
import { createReactI18n } from '@w/react-i18n'
import type { en } from './translations/en'

export type Translations = typeof en

export const { useTranslation, I18nProvider, setLocale, loadTranslations } =
  createReactI18n({
    fallbackLocale: 'en',
    localStorageKey: 'flashcards-locale',
    loadTranslation: async (locale) => {
      if (locale === 'en') return (await import('./translations/en')).en
      if (locale === 'es') return (await import('./translations/es')).es
      throw new Error(`Unsupported locale: ${locale}`)
    },
  })
